import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=cfe24a7a&scoped=true&"
import script from "./cascader.vue?vue&type=script&lang=js&"
export * from "./cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe24a7a",
  null
  
)

export default component.exports